import React, { useCallback } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from 'components/ui/dialog';
import { Company, User, UserType } from '@app/models';
import { ProfileCompany, ProfileUser } from '@app/common';
import { fullName } from '@app/helpers';
import { Button } from 'components/ui/button';

interface Props {
  user: User | null;
  company?: Company | null;
  visible: boolean;
  onClose?: () => void;
}

function ModalProfile(props: Props) {
  const { user, company, visible, onClose } = props;

  const closeModal = useCallback(() => {
    if (onClose) {
      onClose();
    }
  }, [onClose]);

  const titleModal =
    company && user && user.type === UserType.ENTITY
      ? company?.name
      : user
      ? fullName(user)
      : '';

  return (
    <Dialog open={visible} onOpenChange={closeModal}>
      <DialogContent className="max-w-4xl max-h-[90vh] p-0 flex flex-col overflow-hidden">
        <DialogHeader className="flex-shrink-0 p-2">
          <div className="border-b p-4">
            <div className="flex items-center justify-between">
              <DialogTitle className="text-lg font-medium">
                {titleModal}
              </DialogTitle>
            </div>
          </div>
        </DialogHeader>
        <div className="flex-10 overflow-y-auto box-border">
          {company && user && user.type === UserType.ENTITY ? (
            <ProfileCompany
              company={company}
              editable={false}
              showHeader={false}
            />
          ) : user ? (
            <ProfileUser user={user} editable={false} showHeader={false} />
          ) : null}
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default ModalProfile;
